"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const i18n_resources_json_1 = __importDefault(require("./i18n_resources.json"));
const functions_1 = require("@/common/functions");
const languageDetector = {
    type: 'languageDetector',
    detect: () => {
        const detected = (0, functions_1.getCookie)('django_language');
        return detected === 'zh-hans' ? 'zh_hans' : detected;
    },
    init: () => { },
    cacheUserLanguage: () => { },
};
i18next_1.default
    .use(languageDetector)
    .use(react_i18next_1.initReactI18next)
    .init({
    resources: i18n_resources_json_1.default,
    fallbackLng: 'ko',
    keySeparator: false,
    nsSeparator: '|',
    debug: false,
    interpolation: {
        escapeValue: false,
    },
});
exports.default = i18next_1.default;
